import { render } from "./siderbar.vue?vue&type=template&id=6ce4e4b8&scoped=true&ts=true"
import script from "./siderbar.vue?vue&type=script&lang=ts&setup=true"
export * from "./siderbar.vue?vue&type=script&lang=ts&setup=true"

import "./siderbar.vue?vue&type=style&index=0&id=6ce4e4b8&lang=scss&scoped=true"
import "./siderbar.vue?vue&type=style&index=1&id=6ce4e4b8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce4e4b8"],['__file',"src/views/layout/siderbar/siderbar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ce4e4b8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ce4e4b8', __exports__)) {
    api.reload('6ce4e4b8', __exports__)
  }
  
  module.hot.accept("./siderbar.vue?vue&type=template&id=6ce4e4b8&scoped=true&ts=true", () => {
    api.rerender('6ce4e4b8', render)
  })

}


export default __exports__